export default (_, __, { t }) => t('home_seo_description');
